import { useNavigate } from 'react-router-dom';
import { useRoutesProvider } from '../providers/provider-hooks';
import { Button } from '../components/ui/button';
import { IntrariInscriere } from '../domains/auth/components/IntrariInscriere';

export default function HomePage() {
  const navigate = useNavigate();
  const { PAGES, PATHS } = useRoutesProvider();

  return (
    <div className={'overflow-x-hidden overflow-y-scroll bg-white'}>
      {/* Titlul e desenat in imaginea de fundal (`thumbnail_interfata*.jpg`), nu in text —
          pagina n-are niciun titlu real pentru cititoarele de ecran fara asta. */}
      <h1 className="sr-only">Școala Ecoterrienilor</h1>
      <div className="relative flex max-h-screen min-h-screen min-w-screen max-w-screen items-center justify-center bg-white">
        <div className="absolute flex max-h-screen min-h-screen min-w-screen max-w-screen flex-1">
          <img
            src="/thumbnail_interfata_desktop.jpg"
            alt="Home Banner"
            className="hidden max-h-screen min-h-screen min-w-screen max-w-screen object-cover object-right md:flex"
          />
        </div>
        <div className="absolute flex max-h-screen min-h-screen min-w-screen max-w-screen flex-1">
          <img
            src="/thumbnail_interfata.jpg"
            alt="Home Banner"
            // `object-bottom`: pe imaginea editiei 2026-2027 titlul si logourile stau JOS. Unde ecranul
            // taie pe verticala (412x640: 12,6%), se pierde decorul de sus, nu titlul.
            className="flex max-h-screen min-h-screen min-w-screen max-w-screen object-cover object-bottom md:hidden"
          />
        </div>
        <div className="z-10 flex h-full w-full flex-col items-center justify-center space-y-8 bg-black/20 p-20">
          <div className={'flex w-full justify-center'}>
            <Button
              className={
                'flex items-center justify-center rounded-full border-2 border-white px-10 py-5 text-xl shadow'
              }
              onClick={() => navigate(PATHS[PAGES.LOGIN])}
            >
              <span className={'self-center pb-1 text-3xl'}>Autentificare</span>
            </Button>
          </div>
          {/* Aceeasi componenta ca pe ecranul de logare: cine ajunge aici trebuie sa poata
              incepe inscrierea din prima, fara sa treaca intai prin «Autentificare».
              Pe fundal-fotografie, deci intr-o caseta proprie — altfel butonul conturat n-are
              contrast. Latime marginita: la 1440 ar traversa tot ecranul. */}
          <div className="w-full max-w-sm rounded-lg bg-card/90 p-4 backdrop-blur-sm">
            <IntrariInscriere />
          </div>
        </div>
      </div>
    </div>
  );
}
